// extracted by mini-css-extract-plugin
export default {"container":"TAPaywall_container__QiqCf"};